import React, {Component} from 'react';
import {
	AJAX,
	close_popup
} from "../functions";
import {showProgressBarPopup} from "../popups/ProgressBarPopup";
import {showPopupWithGoBack} from "../popups/PopupWithGoBack";
import $ from 'jquery';

class BookingApp extends Component {
	constructor(props) {
		super(props);
		this.sendPhoto = this.sendPhoto.bind(this);
		this.getPhoto = this.getPhoto.bind(this);
		this.state = {file_upload: null, uploadPercent: 0, current_fs: null};
	}

	getPhoto() {
		if (this.state.file_upload)
			return true;
		else
			return null;
	}

	sendPhoto(e) {
		let t = this;
		let file = e.target.files[0];
		if (!file)
			return false;

		let params = {
			photo_key: t.props.photo_key,
			photo_type: this.props.photo_type,
			action: 'api/booking/send_photo_booking',
			files: {
				photo: file
			}
		};

		const target = $(e.target);
		this.state.current_fs = target.closest('fieldset');

		AJAX(bm_ajax_url, 'POST', params, {
			response_json: true,
			func_waiting: ()=>showProgressBarPopup(t.state.uploadPercent),
			func_callback: function (resp) {
				close_popup();
				if (resp.success === 1 && Object.keys(resp.data).length) {
					if (resp.data.url)
						t.setState({file_upload: true, uploadPercent: 0});
					else
						t.setState({file_upload: false, uploadPercent: 0});
					t.state.current_fs.append('<input type="hidden" name="driver_license_images[' + t.props.photo_key + ']" value="' + resp.data.url + '|' + resp.data.bytes + '|' + resp.data.format + '|' + resp.data.resource_type + '"/>');
				} else {
					if (resp.errors.length) {
						showPopupWithGoBack(resp.errors);
					}
				}
			},
			func_error: function (resp) {
				close_popup();
				showPopupWithGoBack(resp.message);
			},
			func_progress: function (evt) {
				if (evt.lengthComputable) {
					let percentComplete = Math.round(evt.loaded / evt.total * 100);
					t.setState({uploadPercent: percentComplete}, () => showProgressBarPopup(t.state.uploadPercent));
				}
			}
		});
	}

	render() {
		return (<>
				<input type="file" id={this.props.photo_key} accept="image/*" capture="camera"
					   className={(this.props.photo_type === 'license' ? 'driver-license-button' : 'driver-selfie-button') + ' ' + (!this.getPhoto() ? 'not-loaded' : '') + ' required'}
					   name={this.props.photo_key}
					   onChange={this.sendPhoto.bind(this)}
				/>
				<label htmlFor={this.props.photo_key} className={"upload-file"}>{
						this.props.photo_type === 'license' ?
							!this.getPhoto() ? "Upload Driver's License" : "Replace Driver's License" :
								!this.getPhoto() ? "Upload Selfie While Holding Driver's License" : "Replace Selfie While Holding Driver's License"
					}
					<span className="star">&nbsp;*</span></label>
		</>);
	}
}

export default BookingApp;
